export const createContestsEditionsStagesRequests = (client) => ({
    listContestsEditionStages: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_stages", {
            params: params,
        });
        return { data, meta, links };
    },
    findContestsEditionStage: async (params) => {
        const { data } = await client.api.get(`contests_edition_stages/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createContestsEditionStage: async (payload) => {
        const { data } = await client.api.create("contests_edition_stages", payload);
        return { data };
    },
    updateContestsEditionStage: async (payload) => {
        const { data } = await client.api.update("contests_edition_stages", payload);
        return { data };
    },
    startContestsEditionStage: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_stage",
            url: `/contests_edition_stages/${payload?.id}/start`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    stopContestsEditionStage: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_stage",
            url: `/contests_edition_stages/${payload?.id}/stop`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    deleteContestsEditionStage: async (id) => {
        return client.api.remove("contests_edition_stages", id);
    },
    autoAssignContestsEditionStageTables: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_stage",
            url: `/contests_edition_stages/${payload?.contestsEditionStageId}/auto_assign_tables`,
            method: "POST",
            body: payload,
        });
        return { data };
    },
    getStageLiveStats: async (payload) => {
        return client.api.request({
            type: "contests_edition_stages",
            url: `/contests_edition_stages/${payload.contestsEditionStageId}/live_stats`,
            method: "GET",
        });
    },
});
//# sourceMappingURL=index.js.map